export default {"src":"/frontend-static/_next/static/media/appStoreDe.673eadec.svg","height":40,"width":120,"blurWidth":0,"blurHeight":0};